import React from 'react';
import classNames from 'classnames';

import './second-title.scss';

type SecondTitleProps = {
    text: string;
    className?: string;
    children?: React.ReactNode;
};

const SecondTitle: React.FC<SecondTitleProps> = ({ text, className, children }) => {
    return (
        <div className={classNames({
            'second-title': true,
            [String(className)]: Boolean(className)
        })}
        >
            <h2 className="primary">
                {text}
            </h2>
            <span className="secondary">
                {children}
            </span>
        </div>
    );
};

export default SecondTitle;
